/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferrerRequest
 */
export interface UpdateReferrerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferrerRequest
     */
    referrerEmail: string;
    /**
     * Admin comment
     * @type {string}
     * @memberof UpdateReferrerRequest
     */
    comment: string;
}

/**
 * Check if a given object implements the UpdateReferrerRequest interface.
 */
export function instanceOfUpdateReferrerRequest(value: object): value is UpdateReferrerRequest {
    if (!('referrerEmail' in value) || value['referrerEmail'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function UpdateReferrerRequestFromJSON(json: any): UpdateReferrerRequest {
    return UpdateReferrerRequestFromJSONTyped(json, false);
}

export function UpdateReferrerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferrerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'referrerEmail': json['referrerEmail'],
        'comment': json['comment'],
    };
}

export function UpdateReferrerRequestToJSON(value?: UpdateReferrerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'referrerEmail': value['referrerEmail'],
        'comment': value['comment'],
    };
}

